import { render, staticRenderFns } from "./CreditCalculationCard.vue?vue&type=template&id=4b562620&"
import script from "./CreditCalculationCard.vue?vue&type=script&lang=js&"
export * from "./CreditCalculationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports